import { authTokenAxios, schoolTokenAxios } from "../axios";

const REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;

let reporting_url = `${REPORTING_BASE}/certificateTemplate`;

export const upsertCertificateTemplate = (payload) => {
  return schoolTokenAxios.post(`${reporting_url}/upsertCertificateTemplate`, payload);
};

export const getCertificateTemplatesList = (params) => {
  return schoolTokenAxios.get(`${reporting_url}/getCertificateTemplatesList`, {
    params,
  });
};

export const getCertificateTemplates = (params) => {
  return schoolTokenAxios.get(`${reporting_url}/getCertificateTemplates`, {
    params,
  });
};

